import React from 'react';
import { useTranslation } from "react-i18next";
import {Trans} from "react-i18next";

const PrivacyPolicy = (props) => {
  const {privacyLink, privacyCtaLabel, thirdScenario} = props;
  const textLabel = thirdScenario ? "form.privacy.label.third_scenario" : "form.privacy.label";
  const { t } = useTranslation();

const PrivacyLink = ({ children, href }) => (
  <a className="privacy-link" href={href} target="_blank" rel="noopener noreferrer">
    {children}
    <span className="sr-only">{t("form.privacy.label.pdf")}</span></a>
);

  return (
    <Trans
      i18nKey={textLabel}
      values={{ctaLabel: privacyCtaLabel}}
      parent=""
      components={[<strong></strong>,<PrivacyLink href={privacyLink} />]}
    />
  )
};

export default PrivacyPolicy;
